import React from 'react'
import { AlertCircle } from 'react-feather'
import { useLocation } from 'react-router-dom'
import shallow from 'zustand/shallow'

import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

import hourGlass from '@frame/images/hour-glass.svg'
import { useStore } from '@frame/lib/stores/useStore'
import { getTextForVerificationType } from '@frame/lib/utils/session'
import { DataAttribute } from '@frame/types'

export function Exit() {
  const location = useLocation()
  const { verificationType } = useStore(
    (state) => ({
      verificationType: state.session?.verification_type,
    }),
    shallow
  )
  const incomeOrEmployment = getTextForVerificationType(verificationType)

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding />
      <Body data-cy={DataAttribute.SCREEN_EXIT} className="p-5">
        <div>
          <div className="mb-4 flex items-center text-center">
            <Span className="flex h-[28px] w-[28px] items-center justify-center rounded-full bg-fire-500 bg-opacity-10 text-fire-500">
              <AlertCircle size={16} />
            </Span>{' '}
            <H2 className="ml-2">Verification incomplete!</H2>
          </div>
          <P className="mb-2">
            {location.state?.fromEmployerNotFoundScreen ? (
              <>
                We apologize for the inconvenience. We'll try our best to verify your income and employment information
                via other methods.
              </>
            ) : (
              <>
                To avoid delays with your application, please finish your{' '}
                <Span className="font-medium">{incomeOrEmployment}</Span> verification promptly.
              </>
            )}
          </P>
        </div>
        <div className="flex h-full justify-center">
          <img className="relative mt-4 max-w-[140px]" src={hourGlass} />
        </div>
      </Body>
    </>
  )
}
